import { createUseStyles } from 'react-jss'

import { darkGrey } from '../../../../../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  spoiler: {
    color: darkGrey
  },
  spoilerTitle: {
    fontSize: 14,
    marginLeft: 0,
    marginTop: 16
  },
  arrowIcon: {
    marginRight: 12
  },
  advancedSettingsSection: {
    marginBottom: 0
  },
  advancedSettingsContainer: {
    marginTop: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  },
  advancedSettingsDescription: {
    // reset '.section p' margin top
    marginTop: [0, '!important']
  }
})

export default useStyles
